import { useCallback, useState } from 'react'
import SideModalWrapper from '../../features/Assets/modals/SideModalWrapper'
import LocationForm from '../../features/Locations/LocationForm'
import ProductForm from '../../features/Products/ProductTab/ProductForm/ProductForm'
import { createInitialProduct } from '../../features/Products/utils'
import { ILocationByTenantCustomer } from '../../features/Shipments/types'

interface UseModalProps {
  refetch?: () => void
  onSave?: (data: any) => void
  type: 'location' | 'productModal'
  data?: any
}

export const useModalWithForm = ({ refetch, onSave, type, data }: UseModalProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [modalData, setModalData] = useState(null)

  const openModal = useCallback(() => {
    setIsModalOpen(true)
  }, [])

  const closeModal = useCallback(() => {
    if (refetch) refetch()
    setIsModalOpen(false)
  }, [refetch])

  const saveModal = useCallback(
    (data: any) => {
      if (onSave) onSave(data)
      setModalData(data)
      setIsModalOpen(false)
    },
    [onSave]
  )

  const renderForm = () => {
    switch (type) {
      case 'location':
        return (
          <LocationForm
            isCustomerDisabled={data?.isCustomerDisabled ?? false}
            location={data as ILocationByTenantCustomer}
            locationTypeId={data?.locationTypeId}
            isSelectLocationType={data?.isSelectLocationType}
            onSubmit={(data) => {
              saveModal(data)
            }}
          />
        )
      case 'productModal': {
        const productData = data
          ? data
          : createInitialProduct(data?.customerId)
        return (
          <ProductForm
            product={productData}
            isDisabled={false}
            onSubmit={(data) => {
              saveModal(data)
            }}
          />
        )
      }
      default:
        return null
    }
  }

  const ModalComponent = (
    <SideModalWrapper
      open={isModalOpen}
      headerLabel={type === 'location' ? 'Location Form' : 'Product Form'}
      onClose={closeModal}
      onSave={() => saveModal(modalData)}
    >
      {renderForm()}
    </SideModalWrapper>
  )

  return {
    isModalOpen,
    openModal,
    closeModal,
    saveModal,
    modalData,
    ModalComponent,
  }
}
